import { Component, OnInit } from '@angular/core';
import { APIService } from '../../api.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-gspc-reconcile',
  templateUrl: './gspc-reconcile.component.html',
  styleUrls: ['./gspc-reconcile.component.scss']
})
export class GspcReconcileComponent implements OnInit {

  meterRdng: string = "";
  confirmMeterRdng: string = "";
  jarvisData: any = [];
  agencyData: any = [];
  erpConfigData: any = [];
  aCookie: any = [];
  errTxt: string = '';
  errTxtVisible: boolean = false;
  errTxtType: string = 'success';
  itemID: number = 0;
  userName: string = "";
  address: string = "";

  constructor(private apiService: APIService,private SpinnerLoader: NgxSpinnerService) { }

  ngOnInit(): void {
    let agencyData = this.apiService.getCookie("M");
    if (agencyData) {
      this.agencyData = JSON.parse(agencyData);
      if (this.agencyData.length > 0 && this.agencyData[0].IsGSPCPump == 0) {
        window.location.href = "https://biziverse.com/main.html#/home";
        return;
      }
    }

    let erpConfigData = this.apiService.getCookie("ERP_Cfg");
    if (erpConfigData) {
      this.erpConfigData = JSON.parse(erpConfigData);
      if (this.erpConfigData.length > 0 && this.erpConfigData[0].GSPCItemID == 0) {
        window.location.href = "https://biziverse.com/main.html#/home";
        return;
      }
    }

    if (this.agencyData[0].AddressL1 != "" && this.agencyData[0].AddressL2 != "") {
      this.address = this.agencyData[0].AddressL1 + ", " + this.agencyData[0].AddressL2;
    }
    else if (this.agencyData[0].AddressL1 != "") {
      this.address = this.agencyData[0].AddressL1;
    }
    else {
      this.address = this.agencyData[0].AddressL2;
    }

    if (this.address != "" && this.agencyData[0].City != "") {
      this.address = this.address + ", " + this.agencyData[0].City;
    }

    let aCookie = this.apiService.getCookie("A");
    if (aCookie) {
      this.aCookie = JSON.parse(aCookie);
      if (this.aCookie.length > 0) {
        this.userName = this.aCookie[0].FirstName + " " + this.aCookie[0].LastName;
      }
    }
    
    var jarvis = this.apiService.getCookie("Jarvis");
    if (jarvis) {
      this.jarvisData = JSON.parse(jarvis);
    }

  }

  saveMeterRdng() {
    if((this.meterRdng != this.confirmMeterRdng) || this.confirmMeterRdng == "0") {
      // this.apiService.successAlert("");
      this.errTxt = "Meter readings are not matching."
      this.errTxtVisible = true;
      this.errTxtType = "error";
      return;
    }
    let itemID = this.erpConfigData[0].GSPCItemID ? this.erpConfigData[0].GSPCItemID : 0;
    if (!itemID) {
      this.apiService.successAlert("Invalid ItemID.");
      return;
    }
    let MyLastSyncDT = localStorage.getItem("MyLastSyncDT");

    let data = [{
      'ItemID': itemID,
      'StoreID': '1',
      'NewQty': this.meterRdng,
      'ConfirmNewQty': this.confirmMeterRdng
    }];

    let myParams = [{
      myUserID: this.jarvisData[0].UserID,
      myToken: this.jarvisData[0].WebToken,
      forAgencyID: this.jarvisData[0].AgencyIDs,
      myAgencyIDs: this.jarvisData[0].AgencyIDs,
      myLastSyncDT: MyLastSyncDT,
      isWeb: true,
      ForERPAgencyID: this.agencyData[0].ERPAgencyID,
      actionType: 'Reconcile',
      moduleID: 5,
      data: JSON.stringify(data)
    }];
    this.SpinnerLoader.show();
    this.apiService.sendChange(myParams, this.successReconcile.bind(this), this.failureReconcile.bind(this));
    
  }

  //failureResp - failure handler
  successReconcile(res: any) {
    this.SpinnerLoader.show();
    if (res.error) {
      console.log(res.message);
    }
    else {
      if (res) {
        var reponseData = JSON.parse(res.updatePackage);
        if (reponseData.Table[0].ErrCode == 1) {
          this.apiService.successAlert(reponseData.Table[0].ErrMsg);
        }
        else {
          this.apiService.successAlert("Updated Successfully.");
          this.meterRdng = "";
          this.confirmMeterRdng = "";
          this.errTxtVisible = false;
        }
      }
    }
  }

  //successResp - success get handler
  failureReconcile(res: any) {
    if (res.error) {
      console.log(res.message);
    }
  }

  backToHomeBtn() {
    window.location.href = "https://biziverse.com/main.html#/home";
  }

  onFocusEvent(event: FocusEvent): void {
    const input = event.target as HTMLInputElement;
    if (input.value === '0') {
      this.errTxtVisible = false;
      input.value = ''; // Clear the value
    }
  }

}
